import React, { useState } from 'react';
import Footer from '../Components/Footers/Footer';
import Header from '../Components/Headers/Header';
import '../assests/css/MyProfile.css';
import ViewProfile from '../Components/Profile/ViewProfile';
import EditProfile from '../Components/Profile/EditProfile';
import { useNavigate } from 'react-router-dom';
import profile_image from '../assests/images/profile_image.png';
import { faPen } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../assests/css/font-size-family.css';
// import MyBookings from '../Components/Profile/MyBookings';
// import profile_image from '../assests/images/profile_image.png';

const MyProfile = () => {

    const [state, setState] = useState(1);

    const ChangeProfileContent = (e) => {
        setState(e);
    }
    let navigate = useNavigate();

    return (
        <div className='myProfile'>
            <section className='bg-privacy-policy-top mb-5'>
                <Header />
                <div className='container px-5'>
                    <div className='row px-3'>
                        <div className='col-lg-12 my-4 text-center'>
                            <p className='text-white f-72 my-5 f-pop-med'>My Profile</p>
                        </div>
                    </div>
                </div>
            </section>

            <div className='viewprofile'>
                <div className='container  my-5'>
                    <div className='row my-5'>
                        <div className='col-lg-12 '>
                            <button className='btn btn-danger bt-aboutus f-14 f-pop-med mt-5 bt-profile bx-shadow'>My Account</button>
                            <button onClick={() => { navigate("/bookinghistroy") }} className='btn btn-secondary bt-aboutus f-14 f-pop-med mt-5 bt-mybookings ms-3 ms-res-bookings'>My Bookings</button>
                        </div>
                    </div>
                </div>
                <div className='container  my-5'>
                    <div className='col-lg-12 mt-5'>
                        <div className='row'>
                            <div className='col-lg-8'>
                                <p className='f-25 f-pop-med mt-0 mb-4'>Basic Information</p>
                                <p className='f-20 f-pop-med'>Photo</p>
                                <p className='f-20 f-pop-med clr-gr-profile mb-4'>Upload / Change Photo</p>
                                <div className='row'>
                                    <div className='col-lg-6'>
                                        <p className='f-15 f-pop-med clr-gr-profile'>First Name</p>
                                        <p className='f-15 f-pop-med  mb-3'>Lorem</p>
                                    </div>
                                    <div className='col-lg-6'>
                                        <p className='f-15 f-pop-med clr-gr-profile'>Last Name</p>
                                        <p className='f-15 f-pop-med  mb-3'>Ipsum</p>
                                    </div>
                                    <div className='col-lg-6'>
                                        <p className='f-15 f-pop-med clr-gr-profile'>Gender</p>
                                        <p className='f-15 f-pop-med  mb-3'>Male</p>
                                    </div>
                                    <div className='col-lg-6'>
                                        <p className='f-15 f-pop-med clr-gr-profile'>Date of Birth</p>
                                        <p className='f-15 f-pop-med  mb-3'>Feb, 09, 2022</p>
                                    </div>
                                    <div className='col-lg-6 '>
                                        <p className='f-15 f-pop-med clr-gr-profile'>Phone</p>
                                        <p className='f-15 f-pop-med  mb-3'>01279 247 247</p>
                                    </div>
                                </div>
                            </div>
                            <div className='col-lg-4 text-strt-res-booking text-end '>
                                <p onClick={() => { navigate("/editprofile") }} className='me-3 f-pop-semibold f-20 cursor-pointer'>   <FontAwesomeIcon className='star_contact mx-1' icon={faPen} /> Edit Profile</p>
                                <img src={profile_image} className=' mb-5' alt="profile_image" />
                            </div>
                            <div className='col-lg-12'>
                                <div className='brdr-btm-gry  mb-5'>

                                </div>
                            </div>
                            <div className='col-lg-12'>
                                <p className='f-25 f-pop-med mb-4'>Account</p>
                            </div>
                            <div className='col-lg-12'>
                                <div className='row'>
                                    <div className='col-lg-8'>
                                        <div className='row'>
                                            <div className='col-lg-6'>
                                                <p className='f-15 f-pop-med clr-gr-profile'>Username / Email</p>
                                                <p className='f-15 f-pop-med  mb-5'>ABC@gmail.com</p>
                                            </div>
                                            <div className='col-lg-6'>
                                                <div className='d-flex align-item-center'>
                                                    <div>
                                                        <p className='f-15 f-pop-med clr-gr-profile'>Password</p>
                                                        <p className='f-15 f-pop-med mt-2'>********</p>
                                                    </div>
                                                    <div className='ms-5'>
                                                        <p  onClick={() => { navigate("/changepassword") }} className='f-15 f-pop-med chng_pass_profile'>Change Password</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-lg-4'>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>



            {(state == 2) && <section className='second_sec edit_profile mt-5'>
                <EditProfile ChangeProfileContent={ChangeProfileContent} />
            </section>
            }

            <Footer />
        </div>
    );
};

export default MyProfile;